import { createAction } from 'typesafe-actions';

import { SetLoadingPayload } from './loading.types';

export const setLoading = createAction('SET_LOADING')<SetLoadingPayload>();
